import request from '@/config/api';

/**
 * 学员管理API
 */

// 获取学员列表
export function getStudentList(params) {
  return request({
    url: "/student/getStudentList",
    method: "get",
    params,
  });
}

// 获取学员详情
export function getStudentDetail(studentId) {
  return request({
    url: `/student/getStudentDetail`,
    method: "get",
    params: { studentId },
  });
}

// 添加学员
export function addStudent(data) {
  return request({
    url: "/student/addStudent",
    method: "post",
    data,
  });
}

// 更新学员信息
export function updateStudent(studentId, data) {
  return request({
    url: `/student/updateStudent`,
    method: 'post',
    data: { studentId, ...data },
  });
}

// 删除学员
export function deleteStudent(studentId) {
  return request({
    url: `/student/deleteStudent`,
    method: 'post',
    data: { studentId },
  });
}

// 更新学员设置
export function updateStudentSettings(studentId, settings) {
  return request({
    url: `/student/updateStudentSettings`,
    method: 'post',
    data: { studentId, settings },
  });
}

// 获取学员课程列表 (使用getStudentDetail接口的courses字段)
export function getStudentCourses(studentId) {
  return request({
    url: `/student/getStudentDetail`,
    method: 'get',
    params: { studentId },
  });
}

// 为学员分配课程
export function addStudentCourse(studentId, courseId, data) {
  return request({
    url: `/teacherCourse/assignCourseToStudent`,
    method: 'post',
    data: { studentId, courseId, ...data },
  });
}

// 移除学员课程 (使用自定义接口,需要后端支持)
export function removeStudentCourse(studentId, courseId) {
  return request({
    url: `/student/removeStudentCourse`,
    method: 'post',
    data: { studentId, courseId },
  });
}

// 续期课程 (使用自定义接口,需要后端支持)
export function extendCourse(studentId, courseId, data) {
  return request({
    url: `/student/extendCourse`,
    method: 'post',
    data: { studentId, courseId, ...data },
  });
}

// 获取每日学习数据
export function getStudentDailyData(params) {
  return request({
    url: `/student/getStudentDailyData`,
    method: 'get',
    params,
  });
}

// 获取学习时间统计 (时间统计+时段分布)
export function getStudentLearningTime(studentId) {
  return request({
    url: `/student/getStudentLearningData`,
    method: 'get',
    params: { studentId, type: 'time' },
  });
}

// 获取学员测试记录
export function getStudentTestRecords(params) {
  return request({
    url: `/student/getStudentTestRecords`,
    method: 'get',
    params,
  });
}

// 获取每日统计
export function getDailyStats(params) {
  return request({
    url: `/student/getStudentDailyData`,
    method: 'get',
    params,
  });
}

// 获取每日学习记录
export function getDailyRecords(params) {
  return request({
    url: `/student/getStudentDailyData`,
    method: 'get',
    params,
  });
}

// 获取测试统计
export function getTestStats(params) {
  return request({
    url: `/test_management/getStudentTestStats`,
    method: 'get',
    params,
  });
}

// 获取测试记录
export function getTestRecords(params) {
  return request({
    url: `/test_management/getTestRecordList`,
    method: 'get',
    params,
  });
}

// 删除测试记录
export function deleteTestRecord(testId) {
  return request({
    url: `/test_management/deleteTestRecord`,
    method: 'post',
    data: { recordId: testId },
  });
}

// 获取课程列表
export function getCourseList() {
  return request({
    url: `/student/getCourseList`,
    method: "get"
  });
}

// 获取可用课程列表
export function fetchAvailableCourses() {
  return request({
    url: `/course/getCourseList`,
    method: "get"
  });
}
